import styled from 'styled-components';
import { Box, type BoxProps } from '../../../../layout/Box';
import { Flex, type FlexProps } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';

export const TitleFlex = styled(Flex)
    .withConfig({
        displayName: 'ContentPromotionTitle',
    })
    .attrs<FlexProps>({
        direction: 'row',
        alignItems: 'center',
    })``;

export const TitleIcon = styled(Box)
    .withConfig({
        displayName: 'ContentPromotionTitleIcon',
    })
    .attrs<BoxProps>({
        width: 32,
        minWidth: 32,
        height: 32,
        mr: 2,
        borderRadius: '50%',
        backgroundColor: 'var(--accent-purple)',
    })``;

export const TitleTypography = styled(Typography).withConfig({
    displayName: 'ContentPromotionTitleTypography',
})``;
